import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es una dieta restrictiva?',
  answer: 'No. Es un sistema estructurado diseñado para estabilizar tu metabolismo sin eliminar grupos completos de alimentos. La idea es construir estructura metabólica inteligente, no privarte.'
}, {
  question: '¿Funciona si estoy en perimenopausia?',
  answer: 'Sí. Está diseñado específicamente para mujeres 40+ en transición hormonal. El sistema contempla los cambios del estrógeno, progesterona, insulina y cortisol propios de esta etapa.'
}, {
  question: '¿Necesito mucho tiempo para cocinar?',
  answer: 'No. El sistema incluye organización y batch cooking para reducir decisiones y ahorrar tiempo. Está pensado para mujeres profesionales con agenda ocupada.'
}, {
  question: '¿Qué pasa si me vuelvo a inflamar?',
  answer: 'Incluye el Bono "Protocolo Express 72 Horas", un sistema de rescate rápido para estabilizarte rápidamente si tenés un episodio de inflamación. Nunca más sentir que "perdiste todo".'
}, {
  question: '¿Cuándo empezaré a notar cambios?',
  answer: 'Muchas mujeres notan menos inflamación ya en la primera fase (7 días), siguiendo el sistema paso a paso. Los resultados varían según cada persona, pero el sistema está diseñado para resultados progresivos y sostenibles.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-9">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-10">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-11">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-12">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-14" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-15">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}